import apiClient from "./axios";

export const getEngineCcs = async (params = {}) => {
  const { data } = await apiClient.get("/engine-ccs", { params });
  return data;
};

export const getEngineCc = async (id) => {
  const { data } = await apiClient.get(`/engine-ccs/${id}`);
  return data;
};

export const createEngineCc = async (engineCcData) => {
  const { data } = await apiClient.post("/engine-ccs", engineCcData);
  return data;
};

export const editEngineCc = async ({ id, ...engineCcData }) => {
  const { data } = await apiClient.patch(`/engine-ccs/${id}`, engineCcData);
  return data;
};

export const deleteEngineCc = async (id) => {
  const { data } = await apiClient.delete(`/engine-ccs/${id}`);
  return data;
};
